require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/$.core').Object.setPrototypeOf;


//////////////////
// WEBPACK FOOTER
// C:/wamp/www/node_modules/core-js/library/fn/object/set-prototype-of.js
// module id = 245
// module chunks = 0